<template>
  <p class="text-primary">
    <template v-if="!!paymentMethod">{{ paymentMethod }}</template>
    <template v-else>Nie wybrano metody płatności</template>
  </p>
</template>

<script>
export default {
  name: 'order-info-payment',
  props: [
    'paymentMethod'
  ]
}
</script>
